import { del, get, set } from 'idb-keyval';

const KEY = 'spriteer-source-image';

type Stored = { buffer: ArrayBuffer; type: string };

function blobToArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
  if (typeof blob.arrayBuffer === 'function') {
    return blob.arrayBuffer();
  }
  // Fallback for environments (e.g. jsdom) where Blob.arrayBuffer is unavailable.
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as ArrayBuffer);
    reader.onerror = () => reject(reader.error);
    reader.readAsArrayBuffer(blob);
  });
}

export async function saveSourceBlob(blob: Blob): Promise<void> {
  const buffer = await blobToArrayBuffer(blob);
  await set(KEY, { buffer, type: blob.type } satisfies Stored);
}

export async function loadSourceBlob(): Promise<Blob | null> {
  const value = await get<Stored>(KEY);
  if (!value) return null;
  return new Blob([value.buffer], { type: value.type });
}

export async function clearSourceBlob(): Promise<void> {
  await del(KEY);
}
